<template>
  <!-- Stats -->
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
      <div class="stats-inner-box">
        <div class="row" style="height: 100%">
            <div class="col-8">
              <p>Current Ending Stock</p>
              <p class="stats-value" v-if="data">
                {{numberWithCommas(data.current_stock)}} Item{{(data.current_stock>1) ? 's' : ''}}
              </p>
              <p class="stats-value" v-else>
                Loading.....
              </p>
              <!-- <h2>2,000,000</h2> -->
            </div>
            <div class="col-4 icon">
              <i class="fas fa-motorcycle"></i>
            </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
      <div class="stats-inner-box" style="background-color:#49B6D6">
          <div class="row" style="height: 100%">
              <div class="col-8">
                <p>Most Type In Stock (#1)</p>
                <p class="stats-value mt-2" v-if="data && data.most_types && data.most_types.length > 0" style="font-size:1.5em">
                  {{data.most_types[0].type}}
                  <!-- <span class="stats-value-support">({{numberWithCommas(data.most_types[0].jml)}} Item{{(data.most_types[0].jml > 1) ? 's' : ''}})</span> -->
                </p>
                <p class="stats-value mt-2" v-else>
                  Loading.....
                  <!-- <span class="stats-value-support">(- Item)</span> -->
                </p>
              </div>
              <div class="col-4 icon">
                <i class="fas fa-boxes"></i>
              </div>
          </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
      <div class="stats-inner-box" style="background-color: #F59C1A">
          <div class="row" style="height: 100%">
              <div class="col-8">
                <p>Most Type In Stock (#2)</p>
                <p class="stats-value mt-2" v-if="data && data.most_types && data.most_types.length > 0" style="font-size:1.5em">
                  {{data.most_types[1].type}}
                  <!-- <span class="stats-value-support">({{numberWithCommas(data.most_types[1].jml)}} Item{{(data.most_types[1].jml > 1) ? 's' : ''}})</span> -->
                </p>
                <p class="stats-value mt-2" v-else>
                  Loading.....
                  <!-- <span class="stats-value-support">(- Item)</span> -->
                </p>
              </div>
              <div class="col-4 icon">
                <i class="fas fa-box"></i>
              </div>
          </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 stats-outer-box">
      <div class="stats-inner-box" style="background-color: #FF5B57">
          <div class="row" style="height: 100%">
              <div class="col-8">
                <p>Most Type In Stock (#3)</p>
                <p class="stats-value mt-2" v-if="data && data.most_types && data.most_types.length > 0" style="font-size:1.5em">
                  {{data.most_types[2].type}}
                  <!-- <span class="stats-value-support">({{numberWithCommas(data.most_types[2].jml)}} Item{{(data.most_types[2].jml > 1) ? 's' : ''}})</span> -->
                </p>
                <p class="stats-value mt-2" v-else>
                  Loading.....
                  <!-- <span class="stats-value-support">(- Item)</span> -->
                </p>
              </div>
              <div class="col-4 icon">
                <i class="fas fa-box-open"></i>
              </div>
          </div>
      </div>
    </div>
  </div>
  <!-- / Stats -->
</template>

<script>
  export default {
    data () {
      return {

      }
    },
    props : ['data'],
    mounted () {

    },
    methods : {

    }
  }
</script>

<style scoped>
  .stats-outer-box{
    padding:20px;
  }

  .stats-inner-box{
    border-radius: 10px;
    background-color: #348FE2;
    height: 85px;
  }

  .stats-inner-box p, .stats-inner-box h2{
    color: white;
  }
  .stats-inner-box p{
    margin:5% 0 0 12.5%;
  }
  .stats-inner-box .stats-value{
    margin-top: 0;
    margin-left:10%;
    font-size: 2em;
    font-weight: 500;
  }
  .stats-inner-box .stats-value .stats-value-support{
    font-size: 0.5em;
    font-weight: normal;
  }
  .stats-inner-box h2{
    margin-left:10%
  }
  .stats-inner-box .icon{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .stats-inner-box .icon i{
    color: #00000050;
    font-size: 3em;
  }
</style>